import { Link } from "react-router";
import { Pages } from "../../../utils";
import { AccessOfferLink } from "./AccessOfferLink";

export const OfferBarSection = () => {
  return (
    <section className="offer-bar">
      <div className="offer-bar-inner">
        <div>
          <p className="offer-label">Home Design Guild Member Price</p>
          <p className="offer-price">
            $1,500 / year <span className="offer-original">$1,749</span>
          </p>
        </div>

        <div className="offer-divider-v" aria-hidden="true" />

        <p className="offer-desc">
          Enhancify Professional Growth Plan - everything you need to offer
          world-class financing from day one, exclusively for Home Design Guild
          account holders.
        </p>

        <div className="offer-dual-cta">
          <AccessOfferLink className="offer-btn">
            Log In to Access the Offer
          </AccessOfferLink>
          <Link to={Pages.SIGNUP} className="offer-btn-outline">
            New to Home Design Guild? Create a Free Account
          </Link>
        </div>
      </div>
    </section>
  );
};
